var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-alert',{attrs:{"data-testid":"identity-unavailable-2amH8N","closable":false,"type":_vm.alertType,"show-icon":""}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }